import { render, staticRenderFns } from "./ChangeLogList.vue?vue&type=template&id=bb9a8cf8&"
import script from "./ChangeLogList.vue?vue&type=script&lang=ts&"
export * from "./ChangeLogList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports